/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Error_TimeoutInputs */

const en_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timed out`)
};

const zh_hans1_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已超时`)
};

const pt_br2_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo esgotado`)
};

const es_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo agotado`)
};

const fr_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délai dépassé`)
};

const de_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitüberschreitung`)
};

const ru_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время ожидания истекло`)
};

const it_usage_error_timeout = /** @type {(inputs: Usage_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo scaduto`)
};

/**
* | output |
* | --- |
* | "Timed out" |
*
* @param {Usage_Error_TimeoutInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_error_timeout = /** @type {((inputs?: Usage_Error_TimeoutInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Error_TimeoutInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_error_timeout(inputs)
	if (locale === "pt-BR") return pt_br2_usage_error_timeout(inputs)
	if (locale === "es") return es_usage_error_timeout(inputs)
	if (locale === "fr") return fr_usage_error_timeout(inputs)
	if (locale === "de") return de_usage_error_timeout(inputs)
	if (locale === "ru") return ru_usage_error_timeout(inputs)
	if (locale === "it") return it_usage_error_timeout(inputs)
	return en_usage_error_timeout(inputs)
});